import { Component, input, InputSignal } from '@angular/core';
import { FormfieldValuesDTO } from '../../shared/models/callback-on-callnote.model';

@Component({
	selector: 'app-form-field-list',
	templateUrl: './form-field-list.html',
	styleUrl: './form-field-list.scss',
	standalone: false,
})
export class FormFieldList {
	public fields: InputSignal<FormfieldValuesDTO[]> = input.required<FormfieldValuesDTO[]>();
}
